import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { useStableRows } from '~/client/src/shared/hooks/useStableRows'
import type { ResourceTemplateDto } from '~/client/src/shared/resources/domain/resourceSchema'
import { countVisibleResourceInputs } from '~/client/src/shared/resources/resourcePropertyInput'
import { getSystemFormFieldKeys } from '~/client/src/shared/resources/systemFormFields'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import { IResourceFormRow } from './types'

const EMPTY_VALUE = '—'

function formatUpdatedAt(
  value: ResourceTemplateDto['updatedAt'],
  projectDateStore?: ProjectDateStore,
): string {
  if (value == null || !projectDateStore) return EMPTY_VALUE
  const date =
    typeof value === 'number'
      ? new Date(value)
      : typeof value === 'string'
        ? new Date(value)
        : (value as Date)
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE
  return projectDateStore.getMonthDayYearAndTimeToDisplay(date)
}

export function useResourceFormRows(
  templates: readonly ResourceTemplateDto[],
  projectDateStore?: ProjectDateStore,
): IResourceFormRow[] {
  const rows = templates.map(template => ({
    id: template.id,
    resourceTypeId: template.resourceTypeId as ResourceTypeId,
    name: template.name || '',
    appliedToCount: template.appliedObjectsCount ?? 0,
    // Name and the resource's root fields are on every form, so they count
    // towards its associated properties just like the template's own.
    associatedProperties:
      countVisibleResourceInputs(template) +
      getSystemFormFieldKeys(template.resourceTypeId ?? undefined).length,
    createdBy: template.createdBy ?? null,
    updatedAt: formatUpdatedAt(template.updatedAt, projectDateStore),
    updatedBy: template.updatedBy ?? null,
  }))

  return useStableRows(rows)
}
